import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, RadioGroupProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import type { OptionType } from 'components/SGSSelect';

export type SGSRadioProps = RadioGroupProps & {
    label?: string;
    options: OptionType<string>[];
};

const SGSRadio: React.FC<SGSRadioProps> = ({ id, name, options, label, ...props }) => {
    const { t } = useTranslation();

    return (
        <FormControl component="fieldset" fullWidth>
            {label && <FormLabel component="legend">{t(label)}</FormLabel>}
            <RadioGroup aria-label={t(label)} {...props}>
                {options.map((opt) => (
                    <FormControlLabel key={opt.value} value={opt.value} control={<Radio />} label={typeof opt.label === 'string' ? t(opt.label) : opt.label} />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default SGSRadio;
